import fetchManager from '@utils/fetchManager'
import { getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");
// const API_URL = 'http://localhost:8080'

export default {
  getDigitalForms: async () => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/digitalForm`)
    return response
  },
  getDetailDigitalForm: async (id) => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/digitalForm/${id}`)
    return response
  },
  editDigitalForm: async (data) => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/digitalForm`, {
      method: 'PUT',
      data
    })
    return response;
  },
  updateStatusDigitalForm: async (id, data) => {
    const response = await fetchManager(`${API_URL}/SectionManagement/api/amx/cpe/digitalForm/${id}`, {
      method: 'PATCH',
      data
    })
    return response;
  },
}